// extracted by mini-css-extract-plugin
export default {"menuText":"#8A92A6","menuActiveText":"#FFF","subMenuActiveText":"#8A92A6","menuBg":"#FFF","menuHover":"#FF6A00","subMenuBg":"#FFF","subMenuHover":"#FF6A00","sideBarWidth":"236px"};